import {Checkbox, FormControlLabel, FormGroup} from "@mui/material";
import React, {} from "react";
import {connect} from "react-redux";
import {ProjectRoleSet, Roles as RolesType, RoleTypes} from "../../redux/types/firebase";

interface Props {
    onRolesChange: (roles: RolesType) => void
    project: string,
    roles: ProjectRoleSet
}

function ProjectRoles({onRolesChange, project, roles}: Props) {
    const handleCheckboxChange = ({currentTarget}: React.ChangeEvent<HTMLInputElement>) => {
        const role = currentTarget.dataset.role as RoleTypes;

        if (role) {
            const newRoles = {
                ...roles,
                [role]: currentTarget.checked
            };
            onRolesChange(newRoles);
        }
    };

    return (
        <FormGroup>
            <FormControlLabel control={
                <Checkbox inputProps={{
                    "data-role": "editor"
                } as any} checked={roles?.editor as boolean || false} onChange={handleCheckboxChange}/>
            } label={"Editor"}/>
            <FormControlLabel control={
                <Checkbox inputProps={{
                    "data-role": "viewer"
                } as any} checked={roles?.viewer as boolean || false} onChange={handleCheckboxChange}/>
            } label={"Viewer"}/>
            <FormControlLabel control={
                <Checkbox inputProps={{
                    "data-role": "reviewer"
                } as any} checked={roles?.reviewer as boolean || false} onChange={handleCheckboxChange}/>
            } label={"Reviewer"}/>
        </FormGroup>
    );
}
const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(ProjectRoles);
